import { isIOSDevice } from "./runtime_platform.js";

const OVERRIDE_KEY = "perf_low_memory";
const GL_BUFFER_OVERRIDE_KEY = "perf_release_gl_buffer";

let cached: boolean | null = null;
let cached_gl_buffer: boolean | null = null;

const readOverride = ( key: string ): boolean | null =>
{
  try
  {
    const value = localStorage.getItem( key );
    if ( value === "1" ) return true;
    if ( value === "0" ) return false;
  }
  catch
  {
  }
  return null;
};

export const isMemoryConstrained = (): boolean =>
{
  if ( cached === null )
    cached = readOverride( OVERRIDE_KEY ) ?? isIOSDevice();
  return cached;
};

export const isGlBufferReleaseEnabled = (): boolean =>
{
  if ( cached_gl_buffer === null )
    cached_gl_buffer = readOverride( GL_BUFFER_OVERRIDE_KEY ) ?? true;
  return cached_gl_buffer;
};
